import React from 'react';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import FormElement from '@wix/da-ds/pkg/formControls/layouts/FormElement';
import UserInput from '@wix/da-shared-react/pkg/Chat/UserInput';
import { useController, useFormContext } from 'react-hook-form';

import ErrorMessage from '../../../../_partials/Form/ErrorMessage';
import s from './UserInputField.scss';

interface Props {
  name: string;
  isRequired?: boolean;
  label: string;
  placeholder?: string;
}
const UserInputField: React.FC<Props> = ({
  name,
  isRequired,
  label,
  placeholder,
  ...props
}) => {
  const { control } = useFormContext();
  const id = useUniqueId();

  const {
    field: { ref, value, onChange, ...inputProps },
    meta: { invalid },
  } = useController({
    name,
    control,
    defaultValue: '',
  });

  return (
    <FormElement
      inputId={id}
      label={<InputLabelText isRequired={isRequired}>{label}</InputLabelText>}
      details={<ErrorMessage name={name} />}
    >
      <UserInput
        className={invalid ? s['error'] : s['root']}
        prefix={<SearchIcon size={IconSize.SMALL} />}
        users={value ? [value] : []}
        onAddUser={userToAdd => onChange(userToAdd)}
        onRemoveUser={_ => onChange(undefined)}
        onRemoveAll={() => onChange(undefined)}
        onKeyDown={e => value && e.preventDefault()}
        disabled={!!value}
        placeholder={!value ? placeholder : undefined}
        {...props}
        {...inputProps}
      />
    </FormElement>
  );
};
UserInputField.displayName = 'UserInputField';

export default UserInputField;
